__webpack_require__.p = "/zing-home-decor/";